import React, {Component} from 'react';
import Select from "react-select";
import {Spinner} from "react-bootstrap";

class CreateOrderUpgradeComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOs: false,
            isAddon: false,
            isChosseProduct: false,
        }
    }

    changeAddonCpu = (num) => {
        this.props.changeAddonCpu(num);
    }

    changeAddonRam = (num) => {
        this.props.changeAddonRam(num);
    }

    changeAddonDisk = (num) => {
        this.props.changeAddonDisk(num);
    }

    render() {
        return (
            <>
                {/*Sản phẩm*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Chọn Hosting</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listHosting}
                            onChange={ this.props.choosseHosting() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn Hosting'}
                        />
                    </div>
                </div>
                {/*Addon*/}
                <div className="row form-group mt-4">
                    {
                        this.props.isLoadingAddon ? (
                            <div className="text-center col-md-12">
                                <Spinner animation="grow" variant="primary" />
                                <Spinner animation="grow" variant="secondary" />
                                <Spinner animation="grow" variant="success" />
                                <Spinner animation="grow" variant="danger" />
                                <Spinner animation="grow" variant="warning" />
                                <Spinner animation="grow" variant="info" />
                            </div>
                        ) : (
                            <>
                                {
                                    this.props.isFormAddon ? (
                                        <>
                                            <div className="col-md-3 text-right font-weight-bold">Chọn gói nâng cấp</div>
                                            <div className="col-md-8">
                                                <Select
                                                    options={this.props.listProductUpgrade}
                                                    onChange={ this.props.choosseProductUpgrade() }
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder={'Chọn Hosting'}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )
                                }
                            </>
                        )
                    }
                </div>
                {/*  Trừ tiền tài khoản  */}
                {
                    this.props.status === 'Finish' ? (
                        <div className="row form-group mt-4">
                            <div className="col-md-3 text-right font-weight-bold">Trừ tiền tài khoản</div>
                            <div className="col-md-8">
                                <input type="checkbox" name="minusCredit" onChange={ this.changeInput } value={ this.props.minusCredit } />
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </>
        );
    }
}

export default CreateOrderUpgradeComponent;